import classes from "./card.module.scss";

const Card = (props) => {
  const { children } = props;
  return <div className={classes.card}>{children}</div>;
};

export default Card;
